import type { Guest } from "../api/contracts/category-ads";

// A search never starts empty: zero guests can never become a booking. The
// site's configured minimums are topped up on top of this once the config loads.
export const createDefaultGuests = (): Guest[] => [
  { ageType: "adult", bedCapacityType: "full" },
];
